var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAppleIcon = function SvgAppleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.962 14.89c-.033-3.535 2.886-5.256 3.02-5.336-1.652-2.42-4.215-2.75-5.114-2.776-2.153-.228-4.239 1.293-5.333 1.293-1.095 0-2.808-1.27-4.626-1.235-2.34.037-4.53 1.396-5.733 3.51C-1.302 14.65.55 20.976 2.921 24.457c1.187 1.704 2.577 3.61 4.392 3.54 1.778-.072 2.441-1.136 4.587-1.136s2.749 1.136 4.603 1.095c1.907-.031 3.107-1.712 4.254-3.433 1.372-1.952 1.923-3.877 1.946-3.975-.046-.015-3.704-1.419-3.741-5.659ZM15.461 4.488c.955-1.2 1.61-2.83 1.43-4.488-1.384.063-3.116.961-4.11 2.134-.883 1.034-1.672 2.73-1.466 4.321 1.553.116 3.148-.785 4.147-1.968",
    fill: "#B7B7B7"
  })));
};
export default SvgAppleIcon;